import { timeline } from "../../../mocks/portalData";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full border-y border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-center gap-2">
          <span className="h-4 w-1 rounded-full bg-secondary-600"></span>
          <h3 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">事件时间线</h3>
          <span className="ml-1 rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-bold text-secondary-800">
            一个瓜的标准生命周期
          </span>
        </div>
        <p className="mt-2 text-sm text-foreground-600">
          无论多复杂的瓜，都能抽象成这几段标准节奏。对照归档，你一眼就能看出当前处在哪一步。
        </p>

        <div className="relative mt-8">
          <div className="absolute left-0 right-0 top-[13px] hidden h-0.5 bg-background-300 lg:block"></div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {timeline.map((phase, idx) => (
              <div key={idx} className="relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-4">
                <div className="flex items-center gap-2 lg:flex-col lg:items-start">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xs font-black text-background-50">
                    {idx + 1}
                  </span>
                  <div>
                    <p className="text-xs font-medium text-foreground-500">{phase.period}</p>
                    <p className="text-sm font-black text-foreground-950">{phase.point}</p>
                  </div>
                </div>
                <div className="mt-3 border-t border-dashed border-background-200 pt-3 lg:mt-4">
                  {phase.items.map((it, j) => (
                    <p key={j} className="text-xs leading-relaxed text-foreground-700">
                      {it.title}
                    </p>
                  ))}
                  <p className="mt-2 flex items-center gap-1 text-xs font-bold text-primary-600">
                    <i className="ri-price-tag-3-line"></i>
                    {phase.items[0].meta}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6 flex justify-center">
          <button
            type="button"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 bg-background-50 px-5 py-2.5 text-sm font-bold text-foreground-800 hover:border-background-400"
          >
            <i className="ri-time-line text-base"></i>
            查看完整事件档案库
          </button>
        </div>
      </div>
    </section>
  );
}